/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import type { Conversation } from '@zcode/nr/es/shared/api'
import type { UnreadCounts } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  RECEIVE_STREAM_CHANNELS,
  SET_FETCHED_UNFILTERED_CHANNELS,
  SET_FETCHING_STREAM_CONVERSATIONS,
  SET_FETCHING_UNFILTERED_CHANNELS,
  SET_UNREAD_COUNTS,
} from '../constants/index'
import type { ListingIdAndBuildingIdTuple } from '../types'

export const receiveStreamChannels = createAction<
  ReadonlyArray<Omit<Conversation, 'status'>>,
  typeof RECEIVE_STREAM_CHANNELS
>(RECEIVE_STREAM_CHANNELS)
export const setFetchingStreamConversations = createAction<
  { fetching: boolean; ids: ListingIdAndBuildingIdTuple[] },
  typeof SET_FETCHING_STREAM_CONVERSATIONS
>(SET_FETCHING_STREAM_CONVERSATIONS)
export const setFetchedUnfilteredChannels = createAction<
  { fetchedAt: number | null; fetchedAll: boolean },
  typeof SET_FETCHED_UNFILTERED_CHANNELS
>(SET_FETCHED_UNFILTERED_CHANNELS)
export const setFetchingUnfilteredChannels = createAction<
  boolean,
  typeof SET_FETCHING_UNFILTERED_CHANNELS
>(SET_FETCHING_UNFILTERED_CHANNELS)
export const setUnreadCounts = createAction<UnreadCounts, typeof SET_UNREAD_COUNTS>(
  SET_UNREAD_COUNTS
)
